module.exports = __webpack_public_path__ + "static/media/Spine Surgery-Medical History-1@3x.fa2f1556.png";